export default __webpack_public_path__ + "static/media/img--LUX-kitchen-2.2bee3c07.jpg";